import { TemplateElement, defineElement, html, when } from '@webtides/element-js';
import '../../../tab-group/tab-group.js';
import '../../../tab-nav/tab-nav.js';
import '../../../tab-link/tab-link.js';
import '../../../tab-panel/tab-panel.js';
import styles from '../../../../../packages/magnolia-content/magnolia-content.css';

/**
 * @property {string} headline
 */
export default class EBankingTabGroup extends TemplateElement {
    tabs = [];

    constructor() {
        super({ shadowRender: true, mutationObserverOptions: { childList: true, subtree: true }, styles: [styles] });
    }

    properties() {
        return {
            headline: '',
        };
    }

    beforeUpdate() {
        this.collectTabs();
    }

    collectTabs() {
        const items = this.querySelectorAll('mb-e-banking-tab-item');
        this.tabs = Array.from(items).map((item) => ({
            name: item.getAttribute('name'),
            title: item.getAttribute('title'),
        }));
    }

    template() {
        return html`
            <mb-tab-group update-url="false">
                ${when(
                    this.headline,
                    html`<h2 class="text-xl font-medium text-green-medium mb-24">${this.headline}</h2>`,
                )}
                <mb-tab-nav variant="buttons" class="bg-primary-subtle1 !p-2 !grid grid-cols-3">
                    ${this.tabs.map(
                        (tab) =>
                            html`<mb-tab-link for="${tab.name}" variant="button" class="!py-8 [&[active]]:hover:!bg-primary hover:!text-white hover:!bg-primary-subtle5"
                                >${tab.title}</mb-tab-link
                            >`,
                    )}
                </mb-tab-nav>
                <slot></slot>
            </mb-tab-group>
        `;
    }
}

defineElement('mb-e-banking-tab-group', EBankingTabGroup);
